import React from 'react';

import { Route, RouteComponentProps } from 'react-router-dom';

import ExperimentDetailScreen from 'client/app/apps/experiments/ExperimentDetailScreen';
import { experimentsRoutes } from 'client/app/lib/nav/actions';

export default function ExperimentDetailRoute() {
  return (
    <Route
      exact
      path={experimentsRoutes.detail.pathTemplate}
      render={(props: RouteComponentProps<{ id?: string }>) => (
        <ExperimentDetailScreen experimentID={props.match.params.id as ExperimentId} />
      )}
    />
  );
}
